import React, { useEffect, useState } from "react";
import { Table, Form, Row, Col, Spinner, Alert, Card } from "react-bootstrap";
import axios from "axios";
import { Base_URL } from "../url";
import { useNavigate } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
const DocumentTypesScreen = () => {
  const [documentTypes, setDocumentTypes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // replace with actual base url
  const navigate = useNavigate(); // 👈 add this

  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  const fetchDocumentTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Base_URL}/DocumentPostings/GetDocumentTypes`
      );

      setDocumentTypes(response.data);
      setFilteredData(response.data);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch document types");
      setLoading(false);
    }
  };

  // Search filter
  useEffect(() => {
    const filtered = documentTypes.filter((item) =>
      `${item.zCode} ${item.zDescription}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );
    setFilteredData(filtered);
  }, [search, documentTypes]);
 const handleViewDetails = (zCode) => {
    navigate(`/document-details/${zCode}`);
  };
  return (
    <div className="container mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h4 className="mb-3">Document Types</h4>

          {/* Search */}
          <Row className="mb-3">
            <Col md={4}>
              <Form.Control
                type="text"
                placeholder="Search by Code or Description..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </Col>
          </Row>

          {/* Loading */}
          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}

          {/* Error */}
          {error && <Alert variant="danger">{error}</Alert>}

          {/* Table */}
          {!loading && !error && (
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Code</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((doc, index) => (
                    <tr key={doc.zCode}>
                      <td>{index + 1}</td>
                      <td>{doc.zCode}</td>
                      <td>{doc.zDescription}</td>
                      <td>
  <FaInfoCircle
    style={{ cursor: "pointer", color: "#0d6efd" }}
    onClick={() => handleViewDetails(doc.zCode)}
    title="View Details"
  />
</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentTypesScreen;